/** 
*@author: Sirisha.M
*@Description : 
**/
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { connect } from "react-redux";
import Highlighter from "react-highlight-words";
import localStorage from "../../../utils/localStorage";
import StyledTable from "../../../commons/styles/table";
import { DrawerFooter } from "../../../commons/styles/layout";
import themeSettings from "../../../commons/styles/themeSettings.json";
import { API_MODULES, IPAddress, API_RUBUSMASTERS } from "../../../commons/api";
import {
  Form,
  Input,
  message,
  Button,
  Drawer,
  Upload,
  Tabs,
  Modal
} from "antd";
import {
  SearchOutlined,
  EditOutlined,
  PlusOutlined,
  UploadOutlined,
  DownloadOutlined
} from "@ant-design/icons";
import {
  UpdateMasters,
  CreateMasters,
  getSubEquipmentsFileDownloadName,
  getAllSubParameterFileDownloadName,
  getAllSubAttributeFileDownloadName
} from "../APICalls";
import translation from '../Utils/translation';
import { useNavigate } from "react-router-dom";

const APIList = {
  CreateDevices: `${API_MODULES.DevicesCreate}`,
  UpdateDevices: `${API_MODULES.DevicesUpdate}`,
};
const { TabPane } = Tabs;

const SubEquipments = (props) => {
  const [formObject, setFormObject] = useState({});
  const [onDrawerOpen, setOnDrawerOpen] = useState(false);
  const [list, setList] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [searchedColumn, setSearchedColumn] = useState('');
  const [fileDownloadName, setFileDownloadName] = useState('');
  const [ParameterFileName, setParameterFileName] = useState('');
  const [AttributeFileName, setAttributeFileName] = useState('');
  const [searchText, setSearchText] = useState('');
  const hForm = useRef(null);
  const ParameterFormRef = useRef(null);
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);

  let searchInput = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    _getList();
    getFileDownloadName();
    getAttributeFileDownloadName();
    getParameterFileDownloadName();
    // setAliasCode(newParams.AliasCode);
  }, []);

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
    // Handle translation cache updates if needed
  }, [translationCache]);
  const _getList = () => {
    let path = window.location.pathname.split('/rubus/CustomerAssetDevice/DeviceTypesChildren/');
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let url = '';
    url = `${API_RUBUSMASTERS.GET}?SiteId=${siteId}&DeviceType=${path[1]}`;
    let orgHeaders = {
      method: 'GET',
      url,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(orgHeaders)
      .then((response) => {
        setList(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };


  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}

          style={{
            width: 90,
            marginRight: '5px'
          }}
        >
          {translation(translationCache, "Search")}
        </Button>

        <Button
          onClick={() => handleReset(clearFilters, confirm)}

          style={{ width: 90 }}
        >
          {translation(translationCache, "Reset")}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select());
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      )
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const _editRecord = (record) => {
    hForm.current && hForm.current.setFieldsValue(record);
    setFormObject(record);
    setOnDrawerOpen(true);
  };


  const onClose = () => {
    hForm.current &&
      hForm.current.setFieldsValue({
        Code: null,
        Name: null,
        DeviceType: null,
        DisplayCode: null
      });
    setFormObject({});
    setOnDrawerOpen(false);
  };

  const openDrawer = () => {
    hForm.current &&
      hForm.current.setFieldsValue({
        Code: null,
        Name: null,
        DeviceType: null,
        DisplayCode: null
      });
    let formObject = {
      Code: null,
      Name: null,
      DeviceType: null,
      DisplayCode: null
    };
    setFormObject(formObject);
    setOnDrawerOpen(true);
  };


  const onFinish = async () => {
    let path = window.location.pathname.split('/rubus/CustomerAssetDevice/DeviceTypesChildren/');
    hForm.current &&
      hForm.current
        .validateFields()
        .then(async (values) => {
          let payload = {
            ...values,
            DeviceType: path && Array.isArray(path) && path[1] ? path[1] : ''
          };

          if (formObject && formObject.Id) {
            let UpdateResponse = await UpdateMasters(APIList.UpdateDevices, payload, formObject.Id);
            message.success(UpdateResponse && UpdateResponse.message);
          } else {
            let CreateResponse = await CreateMasters(APIList.CreateDevices, payload);
            CreateResponse && message.success(CreateResponse && CreateResponse.message);
          }
          _getList();
          getFileDownloadName();
          hForm.current &&
            hForm.current.setFieldsValue({
              Code: null,
              Name: null,
              DeviceType: null,
              DisplayCode: null
            });
          setFormObject({});
          setOnDrawerOpen(false);
        })
        .catch((error) => {
          console.log(error);
        });
  };

  const getFileDownloadName = async () => {
    let path = window.location.pathname.split('/rubus/CustomerAssetDevice/DeviceTypesChildren/');
    let fileDownloadName = await getSubEquipmentsFileDownloadName(path[1]);
    setFileDownloadName(fileDownloadName && fileDownloadName.file ? fileDownloadName.file : '');
  };

  const openModal = () => {
    setModalVisible(true);
  };

  const getParameterFileDownloadName = async () => {
    let path = window.location.pathname.split('/rubus/CustomerAssetDevice/DeviceTypesChildren/');
    let ParameterFileName = await getAllSubParameterFileDownloadName(path[1]);
    setParameterFileName(ParameterFileName && ParameterFileName.file ? ParameterFileName.file : '');
  };

  const getAttributeFileDownloadName = async () => {
    let path = window.location.pathname.split('/rubus/CustomerAssetDevice/DeviceTypesChildren/');
    let AttributeFileName = await getAllSubAttributeFileDownloadName(path[1]);
    setAttributeFileName(AttributeFileName && AttributeFileName.file ? AttributeFileName.file : '');
  };

  const OnNextClick = (record) => {
    navigate(`/rubus/CustomerAssetDevice/SubDeviceChildren/${record.AliasCode}?type=subDevice`);
  };

  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  let path = window.location.pathname.split('/rubus/CustomerAssetDevice/DeviceTypesChildren/');
  let colum = [
    { key: 'S No', value: 'S No' },
    { key: 'Sub Equipment Code', value: 'Code' },
    { key: 'Sub Equipment Name', value: 'Name' }
  ];
  let columns =
    colum && Array.isArray(colum)
      ? colum
        .map((field) => {
          return {
            title: field.key,
            dataIndex: field.value,
            key: field.value,
            ...getColumnSearchProps(field.value)
          };
        })
      : [];

  let finalColumns = [
    ...columns,
    {
      title: translation(translationCache, 'Actions'),
      dataIndex: 'Actions',
      key: 'Actions',
      render: (_text, record) => (
        <span>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => _editRecord(record)}

          />
          <Button
            type="primary"
            onClick={() => OnNextClick(record)}
            style={{ marginLeft: '10px' }}
          >
            <span>{translation(translationCache, 'Next')}</span>
          </Button>
        </span>
      )
    }
  ];

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'right', }}>
        <Button type='primary' style={{ marginRight: '10px' }} >
          <a href={`${IPAddress.LOCAL}${fileDownloadName}`}>
            <DownloadOutlined style={{ marginRight: '1px' }} />
            <span style={{ marginRight: '10px' }}>
              {translation(translationCache, 'Download')}{' '}
            </span>
          </a>
        </Button>
        <Button type='primary' style={{ marginRight: '10px' }}>
          <Upload
            multiple={false}
            style={{ marginRight: '10px', color: 'white' }}
            onChange={(info) => {
              if (info.file.status === 'done') {
                message.success(info.file.response.message);
                getFileDownloadName();
                _getList();
              } else if (info.file.status === 'error') {
                message.error(info.file.response.message);
              }
            }}
            action={`/api/rubusMaster/upload/devices?SiteId=${siteId}&DeviceTypeAlias=${path[1]}`}
            headers={{
              Authorization: Authorization
            }}
            showUploadList={false}
          >
            <UploadOutlined style={{ marginRight: '1px' }} />
            <span style={{ marginRight: '10px' }}>
              {' '}
              {translation(translationCache, 'Upload')}
            </span>
          </Upload>
        </Button>
        <Button type='primary' onClick={(e) => openModal(e)} style={{ marginRight: '10px' }}>
          {translation(translationCache, 'Upload Data')}
        </Button>
        <Button type='primary' onClick={(e) => openDrawer(e)} style={{ marginRight: '10px' }}>
          <PlusOutlined /> {translation(translationCache, 'Add SubEquipments')}
        </Button>
      </div>
      <Tabs theme={themeSettings}>
        <TabPane>
          <StyledTable size="small"
            columns={finalColumns}
            dataSource={list}
            pagination={
              list.length > 10
                ? {
                  pageSize: '10'
                }
                : false
            }
          />
        </TabPane>
      </Tabs>
      <Modal
        width={'900'}
        title={translation(translationCache, 'Upload and Download Data')}
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={[
          <Button key="back" onClick={() => setModalVisible(false)}>
            {translation(translationCache, 'Cancel')}
          </Button>
        ]}
      >
        <Tabs
          type="card"
          style={{ marginTop: '20px', marginBottom: '30px', color: 'black' }}
          theme={themeSettings}
        >
          <TabPane tab={translation(translationCache, 'Parameters')} key="Parameters">
            <Form
              name="ParameterForm"
              ref={ParameterFormRef}
              theme={themeSettings}
              layout="horizontal"
              labelCol={{ flex: '130px' }}
              labelAlign="right"
              labelWrap
            >
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                <>
                  <Form.Item
                    name="Download Parameters"
                    style={{ width: '50%' }}
                    label={translation(translationCache, 'DownloadParameters')}
                  >
                    <a href={`${IPAddress.LOCAL}${ParameterFileName}`}>
                      <DownloadOutlined
                        style={{ color: 'black', marginRight: '1px' }}
                      />
                      <span style={{ color: 'black' }}>Download</span>
                    </a>
                  </Form.Item>
                  <Form.Item
                    name="Upload Attributes"
                    style={{ width: '50%' }}
                    label={translation(translationCache, 'UploadParameters')}
                  >
                    <Upload
                      multiple={false}
                      style={{ marginRight: '10px', color: 'white' }}
                      onChange={async (info) => {
                        if (info.file.status === 'done') {
                          message.success(info.file.response.message);
                          getParameterFileDownloadName();
                          setModalVisible(false);
                        } else if (info.file.status === 'error') {
                          message.error(info.file.response.message);
                        }
                      }}
                      action={`/api/rubusMaster/upload/parameters?SiteId=${siteId}&SubDeviceTypeAlias=${path[1]}`}
                      headers={{
                        Authorization: Authorization
                      }}
                      showUploadList={false}
                    >
                      <UploadOutlined style={{ marginRight: '1px' }} />
                      <span style={{ color: 'white' }}>Upload</span>
                    </Upload>
                  </Form.Item>
                </>
              </div>
            </Form>
          </TabPane>
          <TabPane tab={translation(translationCache, 'Attributes')} key="Attributes">
            <Form
              name="AttributeForm"
              // ref={AttributeFormRef}
              theme={themeSettings}
              layout="horizontal"
              labelCol={{ flex: '130px' }}
              labelAlign="right"
              labelWrap
            >
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                <>
                  <Form.Item
                    name="Download Attributes"
                    style={{ width: '50%' }}
                    label={translation(translationCache, 'DownloadAttributes')}
                  >
                    <a href={`${IPAddress.LOCAL}${AttributeFileName}`}>
                      <DownloadOutlined
                        style={{ color: 'black', marginRight: '1px' }}
                      />
                      <span style={{ color: 'black' }}>Download</span>
                    </a>
                  </Form.Item>
                  <Form.Item
                    name="Upload Attributes"
                    style={{ width: '50%' }}
                    label={translation(translationCache, 'UploadAttributes')}
                  >
                    <Upload
                      multiple={false}
                      style={{ marginRight: '10px', color: 'white' }}
                      onChange={async (info) => {
                        if (info.file.status === 'done') {
                          message.success(info.file.response.message);
                          getAttributeFileDownloadName();
                          setModalVisible(false);
                        } else if (info.file.status === 'error') {
                          message.error(info.file.response.message);
                        }
                      }}
                      action={`/api/rubusMaster/upload/attributes?SiteId=${siteId}&SubDeviceTypeAlias=${path[1]}`}
                      headers={{
                        Authorization: Authorization
                      }}
                      showUploadList={false}
                    >
                      <UploadOutlined style={{ marginRight: '1px' }} />
                      <span style={{ color: 'white' }}>Upload</span>
                    </Upload>
                  </Form.Item>
                </>
              </div>
            </Form>
          </TabPane>
        </Tabs>
      </Modal>
      <Drawer
        title={formObject && formObject.Id ? translation(translationCache, "Edit SubEquipments") : translation(translationCache, "Add SubEquipments")}
        placement="right"
        width={600}
        closable
        onClose={onClose}
        open={onDrawerOpen}
      >
        <Form labelCol={{ span: 6 }}
          wrapperCol={{ span: 12 }}
          theme={themeSettings}
          layout="horizontal"
          ref={hForm}
          name="Site_form"
          initialValues={formObject}
          onFinish={onFinish}>
          <Form.Item
            name="Code"
            label={translation(translationCache, "Code")}
            rules={[{ required: true, message: translation(translationCache, 'Please enter Code') }]}
          >
            <Input
              style={{
                margin: '10px 0'
              }}
              disabled={formObject && formObject.Id ? true : false}
              placeholder={translation(translationCache, "Please enter Code")}
            />
          </Form.Item>
          <Form.Item
            name="Name"
            label={translation(translationCache, "Name")}
            rules={[{ required: true, message: translation(translationCache, 'Please enter Name') }]}
          >
            <Input
              style={{
                margin: '10px 0'
              }}
              placeholder={translation(translationCache, "Please enter Name")}
            />
          </Form.Item>
          <Form.Item
            name="DisplayCode"
            label={translation(translationCache, "Display Code")}
            rules={[{ required: true, message: translation(translationCache, 'Please enter Display Code') }]}
          >
            <Input
              style={{
                margin: '10px 0'
              }}
              placeholder={translation(translationCache, "Please enter Display Code")}
            />
          </Form.Item>
        </Form>
        <DrawerFooter>
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            {translation(translationCache, 'Cancel')}
          </Button>
          <Button type="primary" onClick={onFinish}>
            {translation(translationCache, 'Submit')}
          </Button>
        </DrawerFooter>
      </Drawer>
    </>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
});

export default connect(mapStateToProps)(SubEquipments);
